// extracted by mini-css-extract-plugin
export default {"productCarousel":"Q0-z"};